import { getCurrencyISOCode } from '@stripe-internal/cldr';
import handleGlobalizeError from '../../internal/errors/handleGlobalizeError/handleGlobalizeError';
const getCldrInstance = (globalize, locale)=>{
    const Cldr = globalize.cldr.constructor;
    const cldr = new Cldr(locale);
    return cldr;
};
function getCldrRawDisplayNameValue(globalize, type, userValue) {
    const value = String(userValue);
    const cldr = getCldrInstance(globalize, value);
    const langScript = [
        cldr.attributes.language,
        cldr.attributes.script
    ].join('-');
    const isFallbackLocale = !value.toLowerCase().startsWith(cldr.attributes.language.toLowerCase());
    let rawValue;
    if (type === 'currency') {
        const currencyCode = getCurrencyISOCode(value);
        rawValue = globalize.cldr.main(`numbers/currencies/${currencyCode}/displayName`);
    } else if (type === 'region') {
        rawValue = globalize.cldr.main(`localeDisplayNames/territories/${value.toUpperCase()}`) || globalize.cldr.main(`localeDisplayNames/territories/${value}`);
    } else if (type === 'language') {
        rawValue = globalize.cldr.main(`localeDisplayNames/languages/${value.toLowerCase()}`) || globalize.cldr.main(`localeDisplayNames/languages/${langScript}`);
    }
    if (!rawValue && !isFallbackLocale) {
        rawValue = getCldrRawDisplayNameValue(globalize, type, getValueFromLocale(cldr, type) || '');
    }
    return rawValue || '';
}
function getValueFromLocale(cldr, type) {
    if (type === 'language') {
        return cldr.attributes.language;
    }
    if (type === 'region') {
        return cldr.attributes.territory;
    }
    return undefined;
}
export default function getCldrDisplayNameValue(globalize, type, value, reports) {
    try {
        return getCldrRawDisplayNameValue(globalize, type, value);
    } catch (error) {
        handleGlobalizeError(error, reports);
    }
}

//# sourceMappingURL=getCldrDisplayNameValue.js.map